import PopoverBase from '../PopoverBase'
import './styles.scss'

export default class Tooltip extends PopoverBase {
  static defaultProps = {
    ...PopoverBase.defaultProps,
    maxWidth: 350,
    triggerEvent: 'hover',
    type: 'tooltip',
  }
}
